(function () {
  if (window.xjFooterDrawerInitialized) return;
  window.xjFooterDrawerInitialized = true;

  window.clDrawerHelper = {
    open: function (id) {
      var el = document.getElementById(id);
      if (!el) return;

      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },

    close: function (id) {
      var el = document.getElementById(id);
      if (!el) return;

      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');

      if (!document.querySelector('.cl-drawer.is-open')) {
        document.body.style.overflow = '';
      }
    }
  };

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-drawer-trigger]');

    if (trigger) {
      var id = trigger.getAttribute('data-drawer-trigger');

      window.clDrawerHelper.open(id);
      trigger.setAttribute('aria-expanded', 'true');

      return;
    }

    var closeBtn = e.target.closest('[data-drawer-close]');

    if (closeBtn) {
      var drawer = closeBtn.closest('.cl-drawer');

      if (drawer) {
        window.clDrawerHelper.close(drawer.id);

        var relatedTrigger = document.querySelector(
          '[data-drawer-trigger="' + drawer.id + '"]'
        );

        if (relatedTrigger) {
          relatedTrigger.setAttribute('aria-expanded', 'false');
        }
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document
        .querySelectorAll('.cl-drawer.is-open')
        .forEach(function (drawer) {
          window.clDrawerHelper.close(drawer.id);

          var relatedTrigger = document.querySelector(
            '[data-drawer-trigger="' + drawer.id + '"]'
          );

          if (relatedTrigger) {
            relatedTrigger.setAttribute('aria-expanded', 'false');
          }
        });
    }
  });
})();